module.exports.default = {
    "ORDER": "Pedido",
    "SCHEDULE.YOU_ARE_ALL_SET": "¡Todo listo!",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Tu entrega esta agendada para",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Hola #. Por favor agenda tu entrega:",
    "SCHEDULE.SCHEDULE_NOW": "Programar ahora",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Entrega & Actualización de Estados",
    "SCHEDULE.EMAIL_UPDATES": "Actualizaciones por correo",
    "SCHEDULE.SMS_UPDATES": "Actualizaciones por SMS",
    "SCHEDULE.DISABLE_UPDATES": "No quiero recibir actualizaciones",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Me gustaría recibir actualizaciones sobre mi entrega en los siguientes canales:",
    "OOPS": "¡Oops!",
    "SOMETHING_WENT_WRONG": "Algo salió mal",
    "REFRESH": "Refrescar",
    "PAGE_NOT_FOUND": "Página no encontrada",
    "COULD_NOT_FIND_PAGE": "No pudimos encontrar la página que estabas buscando.\n\n",
    "TRACKING.MESSAGE_DRIVER_FAILED": "No se puede enviar un mensaje vacío",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Por favor, ingresa tu mensaje al conductor",
    "TRACKING.SEND": "Enviar",
    "TRACKING.ARRIVING_AT": "Llegando",
    "TRACKING.ETA": "Estimado",
    "TRACKING.MIN": "minutos",
    "TRACKING.MAP": "Mapa",
    "TRACKING.SATELLITE": "Satélite",
    "TRACKING.TERRAIN": "Terreno",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "¡Hola, he llegado!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "ha llegado a",
    "COMPLETED": "No tienes entregas activas en este momento",
    "RATING.SKIP": "Ahora no",
    "RATING.WHAT_WENT_WELL": "¿Qué salió bien?",
    "RATING.WHAT_WENT_WRONG": "¿Qué salió mal?",
    "RATING.THANK_YOU": "Gracias",
    "RATING.FOR_USING_OUR_SERVICE": "por usar nuestro servicio",
    "RATING.HOW_WAS_YOUR_DELIVERY": "¿Cómo fue tu experiencia de entrega?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Gracias Por usar nuestro servicio",
    "SCHEDULE.RATE_US": "Califícanos",
    "TERM_OF_USE": "Condiciones de Uso",
    "PRIVACY_POLICY": "Política de Privacidad",
    "SHARING_MY_LOCATION": "Compartir mi localización",
    "SHARING_LOADING": "Cargando",
    "REQUIRED_FIELD_MESSAGE": "Este campo es obligatorio",
    "CONTACT_NAME": "Nombre del Contacto",
    "PHONE_NUMBER": "Número de Teléfono",
    "EMAIL_ADDRESS": "Email",
    "SEND": "Enviar",
    "FORWARD.THIS_ORDER": "Reenviar esta orden",
    "FORWARD.TO_CONTACT": "Reenviar al contacto",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "¿Está seguro de que quiere reenviar este pedido?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "le ha enviado una entrega",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "¿Está seguro de que quiere rechazar este pedido?",
    "ACCEPT": "Aceptar",
    "REJECT": "Rechazar",
    "PICKUP.SET_PICKUP_TIME": "Estoy en camino",
    "PICKUP.IVE_ARRIVED": "He llegado",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Oops, algo falló",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Por favor intentar de nuevo",
    "PICKUP.MIN": "min",
    "PICKUP.SHOW_THIS_NUMBER": "Muestre este número al empleado para recibir su orden",
    "PICKUP.IM_OUTSIDE": "Ya estoy aquí",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Avísenos cuando haya arribado",
    "PICKUP.I_WILL_ARRIVE_AT": "Llegaré a esta hora",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Hora de recogida definida con éxito",
    "PICKUP.IN": "en",
    "PICKUP.TO": "a",
    "PICKUP.COLLECT": "Pedido recogido",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Seleccione método de transporte",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Confirme método de transporte",
    "PICKUP.CANCEL": "Cancelar",
    "PICKUP.CONFIRM_TIME": "Confirmar hora de llegada para recolectar",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "El conductor está actualmente a una parada de ti",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "paradas de ti",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "El conductor está actualmente",
    "PICKUP.OK": "Ok",
    "PICKUP.NEXT": "Siguiente",
    "PICKUP.SKIP": "Saltar",
    "CAR_ARRIVED.TITLE": "¡Último paso! Indícanos como encontrarlo:",
    "CAR_ARRIVED.PARKING_SPOT": "Área de estacionamento / Número de cajón de estacionamiento",
    "CAR_ARRIVED.LICENSE_PLATE": "Número de placa",
    "CAR_ARRIVED.VEHICLE_MODEL": "Modelo y marca del vehículo",
    "CAR_ARRIVED.VEHICLE_COLOR": "Color del vehículo",
    "CAR_ARRIVED.REMEMBER": "Recordar los detalles de mi vehículo",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Ejemplo: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Ejemplo: 195-QUD)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Ejemplo: Ford Bronco)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Ejemplo: Azul)",
    "REDIRECT_PICKUP.TO": "Hacia",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "¿Cambiar la ubicación de recogida?",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Ubicación de recogida cambiada satisfactoriamente.",
    "REDIRECT_PICKUP.FAILED_TITLE": "No se pudo cambiar la ubicación de recogida.",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Algo salió mal",
    "REDIRECT_PICKUP.OK": "Ok",
    "REDIRECT_PICKUP.KM": "km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Seleccione ubicación de recogida",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Seleccionar como ubicación de recogida",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Opciones de recogida",
    "SOON": "Llegando",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "¿Quieres llamar a tu conductor?",
    "GLOBAL.CALL": "Llamar",
    "GLOBAL.CANCEL": "Cancelar",
    "﻿PICKUP.SET_PICKUP_TIME": "Definir hora de recolecta",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Tu pedido esta aguardando en el frente de tu puerta!",
    "SCHEDULED.THANKS_FOR_USING": "Gracias por usar {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Tu pedido {{external_id}} esta en camino",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Tu pedido esta agendado para",
    "Submit": "Enviar",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Para poder calificar, selecciona las estrellas primero",
    "PICKUP.SHOW_ID": "Mostrar ID",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Hora estimada de llegada",
    "OPEN_MENU": "Abrir menú",
    "CLOSE_MENU": "Cerrar menú",
    "MAP_AUTO_CENTER": "Mapa del autocentro",
    "MAP_SETTINGS": "Configuración del mapa",
    "ZOOM_OUT": "Alejar el zoom",
    "ZOOM_IN": "Acercarse",
    "TRACKING.CALL_DRIVER": "Llamar al conductor",
    "TRACKING.MESSAGE_DRIVER": "Enviar un mensaje al conductor",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Confirmar la hora de llegada de la recogida",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "No queremos que esperes. Avísanos cuando estés en camino o llegues:",
    "SCHEDULE.TIME_ZONE_TEXT": "Huso horario",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "¡Estamos trabajando en ello!",
    "TRACKING.THANKS_MESSAGE_TEXT": "Estamos recogiendo sus artículos y un miembro del equipo irá a su coche en breve",
    "TRACKING.THANKS_MESSAGE_TITLE": "Gracias por registrarte",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Diríjase al punto de recogida en la tienda donde su pedido está listo para ser recogido",
    "CANCEL_ORDER": "Cancelar pedido",
    "CANCELLATION_VALIDATION_TITLE": "¿Está seguro de que desea cancelar este pedido?",
    "CANCELLATION_VALIDATION_BACK": "Volver",
    "CANCELLATION_VALIDATION_YES": "Sí, por favor",
    "CANCEL_SUCCESS": "Hemos cancelado su pedido",
    "CANCEL_PAST_ALLOWED": "Cancelación de pedido caducada",
    "CANCEL_ERROR": "No hemos podido anular su pedido",
    "RATING.FREE_TEXT_COMMENT": "Cuéntenos más",
    "RATING.ORDER_DELIVERED_GREEN": "Entregamos su pedido con un vehículo ecológico",
    "CX_ORDER_STATUS.CONFIRMED": "Orden confirmada. Estamos en ello.",
    "CX_ORDER_STATUS.RECEIVED": "Orden recibida. Nos pondremos en contacto en breve.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Estamos buscando un conductor para su pedido.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Hemos encontrado el conductor para su pedido.",
    "CX_ORDER_STATUS.PICKING_UP": "Estamos recogiendo su pedido en este momento.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Estamos en camino para recoger su pedido.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Estamos completando una entrega anterior antes de su pedido.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "¡Su pedido está en camino hacia usted ahora!",
    "CX_ORDER_STATUS.ARRIVED": "¡Su pedido ha llegado!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Estado de entrega",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Mostrar el estado de entrega a los clientes",
    "CONFIRM": "Confirmar",
    "FLOW_OPTIONS.TITLE": "¿Cómo quiere recoger su pedido?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Entregado a su automóvil en un lugar designado",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Acera",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Recogida en la tienda o en una ubicación establecida",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Haga clic y recoja",
    "RATING_STAR_ALT": "Seleccione hasta 5 estrellas para enviar una calificación",
    "RATING_STAR_ALT_ONE": "Seleccione para dejar la calificación de",
    "RATING_STAR_ALT_TWO": "estrellas",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "El tiempo estimado de llegada es de",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Mapa para rastrear el pedido",
    "SCHEDULE.EXTERNAL_ID_INFO": "Pedido ID: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "Comentario",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Eliminar",
    "DELIVERY_WAS_CANCELLED": "Entrega cancelada",
    "QUESTIONNAIRE.SKIP": "Omitir",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "¿Estás seguro de que deseas omitir?",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "Algunas preguntas no han sido respondidas. ¿Estás seguro de que deseas continuar sin completarlas?",
    "QUESTIONNAIRE.BACK": "Volver",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": "",
    "RESCHEDULE.NEED_A_DIFFERENT_TIME": "¿Necesita otro horario?",
    "RESCHEDULE.RESCHEDULE_YOUR_DELIVERY": "Reprogramar su entrega",
    "RESCHEDULE.GREETING": "¡Hola! 👋 Soy el asistente de reprogramación de {{merchant_name}}. Su pedido #{{order_id}} está programado para {{delivery_window}}.\n\n¿Necesita cambiar la franja de entrega? Seleccione una opción abajo y nos encargamos.",
    "RESCHEDULE.FIRST_AVAILABLE": "Primera disponible",
    "RESCHEDULE.SAME_DAY": "Mismo día, otro horario",
    "RESCHEDULE.PICK_A_DATE": "Elegir una fecha",
    "RESCHEDULE.NEAREST_WINDOWS": "Estas son las franjas disponibles más próximas. Seleccione la fecha que le convenga",
    "RESCHEDULE.WINDOWS_FOR_DATE": "Estas son todas las franjas disponibles para el {{date}}. Seleccione la que le convenga",
    "RESCHEDULE.WHICH_DATE": "¿Qué fecha le viene mejor?",
    "RESCHEDULE.NO_WINDOWS": "Lo sentimos, no hay franjas disponibles para ese día. Pruebe con otra fecha",
    "RESCHEDULE.NO_WINDOWS_AVAILABLE": "Lo sentimos, en este momento no hay franjas disponibles para reprogramar.",
    "RESCHEDULE.SOMETHING_WENT_WRONG": "Se ha producido un error al cargar las franjas disponibles. Inténtelo de nuevo.",
    "RESCHEDULE.TRY_AGAIN": "Intentar de nuevo",
    "RESCHEDULE.BACK_TO_START": "Volver al inicio",
    "RESCHEDULE.BACK_TO_DELIVERY": "Volver a mi entrega",
    "RESCHEDULE.CONFIRMED": "¡Listo! La entrega está ahora programada para {{delivery_window}}. ¡Que tenga un buen día!",
    "RESCHEDULE.TYPE_A_MESSAGE": "Escriba un mensaje",
    "RESCHEDULE.TODAY": "Hoy"
};
	